import React from 'react';
import { MCButton, PopoverMenu } from '../basic';
import { remCss, rgba, scssVariables as variables } from 'src/helpers';
import SVGIcon, { BASE_ICONS } from '../svg';
import LANG_CONST from 'src/helpers/lang/const';

const ButtonDropdown = ({
  mainButton,
  menu,
  iconProps = {},
  triggerBoundsWidth = true,
  popupMenuStyle = {},
  ...other
}) => {
  return (
    <PopoverMenu
      placement={'bottom-end'}
      triggerOffset={0}
      autoToggle={false}
      triggerBoundsWidth={triggerBoundsWidth}
      popupMenuStyle={{
        backgroundColor: 'white',
        borderBottomLeftRadius: remCss(5),
        borderBottomRightRadius: remCss(5),
        borderWidth: remCss(1),
        borderStyle: 'solid',
        borderColor: rgba(variables['colors-mc-primary']),
        borderTop: 'none',
        boxSizing: 'border-box',
        transition: 'none',
        ...popupMenuStyle
      }}
      menu={menu}
      {...other}
    >
      {(isOpen, toggle, triggerProps) => (
        <div
          {...triggerProps}
          className={'mc-flex-0 mc-pointer mc-b-primary'}
          style={{
            borderRadius: isOpen ? [remCss(5), remCss(5), 0, 0].join('px ') : remCss(5)
          }}
        >
          {mainButton ? (
            mainButton(toggle)
          ) : (
            <MCButton
              type={'button'}
              light
              primary
              medium
              radius={false}
              style={{ border: 'none' }}
              label={LANG_CONST.buttons.actions}
              onClick={toggle}
            />
          )}
          <MCButton
            primary
            tiny
            light
            hover
            style={{
              borderLeftWidth: remCss(1),
              borderLeftStyle: 'solid',
              borderLeftColor: rgba(variables['colors-mc-primary'])
            }}
            onClick={toggle}
            {...iconProps}
          >
            <span
              className={'mc-rotate ' + (isOpen ? 'mc-rotate-180' : '')}
              style={{ height: remCss(42), width: remCss(42) }}
            >
              <SVGIcon
                iconname={BASE_ICONS.DOWN}
                width={42}
                padding={7}
                fill={variables['colors-mc-primary']}
              />
            </span>
          </MCButton>
        </div>
      )}
    </PopoverMenu>
  );
};

ButtonDropdown.displayName = 'ButtonDropdown';

export default ButtonDropdown;
